import { createContext, useContext } from 'react';

export type BrandTheme = 'orange' | 'blue';

export const BRAND_LOGO_SRC: Record<BrandTheme, string> = {
  orange: '/compbox-logo-orange.svg',
  blue: '/compbox-logo-blue.svg',
};

interface BrandThemeContextValue {
  brand: BrandTheme;
  setBrand: (t: BrandTheme) => void;
}

export const BrandThemeContext = createContext<BrandThemeContextValue | null>(null);

export function useBrandTheme(): BrandThemeContextValue {
  const ctx = useContext(BrandThemeContext);
  if (!ctx) throw new Error('useBrandTheme must be used within BrandThemeProvider');
  return ctx;
}
